import RouterLink from "../../Link/RouterLink";
import { homepage_enterprise } from "../../../Imgs/images";

function Enterprise() {
  return (
    <section className="hp-enterprise">
      <picture className="hp-enterprise-img">
        <source srcSet={homepage_enterprise} />
        <img src={homepage_enterprise} alt="" />
      </picture>
      <div className="hp-enterprise-content">
        <h2 className="sp-section-title sp-no-center sp-no-padding hp-enterprise-title-margin">
          Soudry Préventions et Équipements
        </h2>
        <p className="sp-section-paragraph">
          Fondée en mars 2022 sous le nom de SP Enseignement Normandie, notre
          entreprise a évolué en 2025 pour devenir SOUDRY Préventions et
          Équipements. Dirigée par Kévin Soudry, fort de dix années d'expérience
          dans le domaine de la Qualité, de la Santé, de la Sécurité et de
          l’Environnement (QSSE), nous sommes spécialisés dans divers secteurs
          d'activité, allant de l'industrie aux bâtiments et travaux publics.
        </p>
        <p className="sp-section-paragraph">
          Nous nous engageons à offrir des solutions techniques et des
          formations adaptées aux exigences des organismes privés, publics et
          associatifs dans les métiers du BTP et de l'industrie.
        </p>
        <RouterLink
          to="/entreprise"
          className="sp-button sp-no-margin sp-center-mobile"
        >
          <span className="sp-button-text">Découvrir l'équipe</span>
          <div className="sp-button-arrow"></div>
        </RouterLink>
      </div>
    </section>
  );
}

export default Enterprise;
